module.exports = __webpack_public_path__ + "img/49.c779c7c9.png";